import React from 'react'
import styles from './index.module.css'

function Step(props: {step: number}) {
  return (
    <div className={styles.steplayer}>
      <span style={{width: props.step + '%'}}></span>
    </div>
  )
}

export default Step